import { useQuery } from "@tanstack/react-query";
import { ListVouchersQueryFilters, UseListVouchersQueryOptions } from "./types";
import { getVouchersService } from "./service";

export const listVouchersQueryKey = ["voucher_batch_admin"];

export function useListVouchersQuery(
  filters?: ListVouchersQueryFilters,
  options?: UseListVouchersQueryOptions
) {

  const queryFilters = filters ? { ...filters } : undefined;

  if (queryFilters?.search) {
    delete queryFilters.ids;
  }

  const queryKey = listVouchersQueryKey.concat(JSON.stringify(queryFilters));

  return useQuery({
    queryKey,
    queryFn: async () => getVouchersService(filters),
    ...options,
  });
}
